import { supabase, type Admin } from "../supabase"

// In AdminService.ts
export class AdminService {
  // Authenticate admin by email and password
  static async authenticateAdmin(email: string, password: string): Promise<Admin | null> {
    console.log(email)
    try {
      const { data, error } = await supabase
        .from("admin")
        .select("*")
        .eq("email", email.toLowerCase().trim()) // Case-insensitive match
        .eq("password", password.trim()) // Exact password match
        .maybeSingle();
       
      console.log(data)
      if (error) {
        console.error("Error authenticating admin:", error);
        return null;
      }
       
      return data;
    } catch (error) {
      console.error("Error in authenticateAdmin:", error);
      return null;
    }
  }

  // Create admin with email and password
  static async createAdmin(email: string, password: string): Promise<Admin | null> {
    try {
      const { data, error } = await supabase
        .from("admin")
        .insert([{
          email: email,
          password: password // Again, in production use proper hashing!
        }])
        .select()
        .single();
       
      if (error) {
        console.error("Error creating admin:", error);
        return null;
      }
       
      return data;
    } catch (error) {
      console.error("Error in createAdmin:", error);
      return null;
    }
  }

  // Reset password functionality
  static async resetPassword(email: string, newPassword: string): Promise<boolean> {
    try {
      const { error } = await supabase
        .from("admin")
        .update({ password: newPassword })
        .eq("email", email.toLowerCase().trim());
       
      if (error) {
        console.error("Error resetting password:", error);
        return false;
      }
       
      return true;
    } catch (error) {
      console.error("Error in resetPassword:", error);
      return false;
    }
  }

  // Check if admin email exists (for forgot password)
  static async checkAdminExists(email: string): Promise<boolean> {
    try {
      const { data, error } = await supabase
        .from("admin")
        .select("id")
        .eq("email", email.toLowerCase().trim())
        .maybeSingle();
       
      if (error) {
        console.error("Error checking admin existence:", error);
        return false;
      }
       
      return data !== null;
    } catch (error) {
      console.error("Error in checkAdminExists:", error);
      return false;
    }
  }
}
